interface IButtonProps {
  label: string;
  onClick?: () => void;
  type?: "danger" | "primary";
}

const Button: React.FunctionComponent<IButtonProps> = ({
  label = "",
  onClick = () => {},
  type = "primary",
}) => {
  return (
    <button className={`${type}-btn`} onClick={onClick}>
      {label}
    </button>
  );
};

export default Button;
